import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

type Props = {
  $darkAppearance?: boolean
}

const Alert = styled.div<Props>`
  ${typeStyle('-ds-font-body-light')}
  display: flex;
  align-items: flex-start;

  ${media.md`
    align-items: center;
  `}

  padding: 16px;
  color: ${({ $darkAppearance, theme }) =>
    $darkAppearance ? theme?.['-ds-neutral-700']?.value : '#a92801'};
  background-color: ${({ $darkAppearance, theme }) =>
    $darkAppearance ? theme?.['-ds-information-100']?.value : '#fcf6f5'};
  border-radius: 8px;

  svg {
    flex-shrink: 0;
    height: 30px;
    width: 30px;
    margin-right: 16px;
  }

  margin-bottom: 24px;
`

export default Alert
